import GameSpace from "../Components/GameSpace";

//Page containing the Gamespace component
export default function Game(){

    return(
    <div className='page-container'>
        <GameSpace />
    </div>
    )
}

